const INTENT_KEY = 'intent_perfil_prestador';

/** Persiste intent vindo da LP (`?perfil=prestador`) até o pós-login. */
export function setPrestadorIntent() {
  try {
    sessionStorage.setItem(INTENT_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function hasPrestadorIntent() {
  try {
    return sessionStorage.getItem(INTENT_KEY) === '1';
  } catch {
    return false;
  }
}

/** Lê e limpa o intent. Retorna true se havia intent ativo. */
export function consumePrestadorIntent() {
  try {
    const ok = sessionStorage.getItem(INTENT_KEY) === '1';
    if (ok) sessionStorage.removeItem(INTENT_KEY);
    return ok;
  } catch {
    return false;
  }
}

export function clearPrestadorIntent() {
  try {
    sessionStorage.removeItem(INTENT_KEY);
  } catch {
    /* ignore */
  }
}

export function isPerfilPrestadorParam(value) {
  return String(value || '').toLowerCase() === 'prestador';
}

/** Monta query string preservando ref e/ou perfil=prestador. */
export function buildAuthQuery({ ref, perfilPrestador } = {}) {
  const params = new URLSearchParams();
  if (ref) params.set('ref', ref);
  if (perfilPrestador) params.set('perfil', 'prestador');
  const q = params.toString();
  return q ? `?${q}` : '';
}
